import * as React from 'react';

const ICON_WITHOUT_LABEL_SIZE = 24;

type Props = {
    icon: React.ComponentType<any>;
    label?: string;
    size: number;
    offsetX?: number;
};

export function SidebarIcon(props: Props) {
    const {label, icon: Icon} = props;

    return (
        <div className='nut-sidebar-icon'>
            {props.label ? (
                <>
                    <div
                        className='nut-sidebar-icon--icon-container'
                        // @ts-expect-error
                        style={props.offsetX && {position: 'relative', left: props.offsetX}}
                    >
                        <Icon className='nut-sidebar--icon' wrapWithDiv={false} size={props.size} />
                    </div>
                    <span className='nut-sidebar-label'>{label}</span>
                </>
            ) : (
                <Icon
                    className='nut-sidebar--icon'
                    wrapWithDiv={false}
                    size={ICON_WITHOUT_LABEL_SIZE}
                />
            )}
        </div>
    );
}
